import store from "../store";
import { each, filter } from "lodash";
function filterTopics(topics, options) {
    var excludeGroupIds = (options.excludeGroups || []).map(function(group) {
        return group.id;
    });
    return topics.filter(function(topic) {
        return excludeGroupIds.indexOf(topic.group_id) === -1;
    });
}
function getLastActivity(topic) {
    return topic.last_activity_at ? topic.last_activity_at : topic.updated_at;
}
export function getCurrentTopic() {
    var topics = store.getState().topics;
    var currentTopicId = topics.currentTopicId;
    return currentTopicId ? topics.allTopics[currentTopicId] : null;
}
export function isTopicPersisted(topic) {
    return topic && topic.id >= 0;
}
export function getAllTopicsChronologically(options) {
    var orderedTopics = [];
    var topics = store.getState().topics.allTopics;
    // Only those that are visible ATM
    each(topics, function(topic) {
        if (topic.__hidden !== true) {
            orderedTopics.push(topic);
        }
    });
    orderedTopics = filterTopics(orderedTopics, options || {});
    return sortChrono(orderedTopics);
}
export function sortChrono(topics) {
    return topics.sort(function(a, b) {
        var lastActA = getLastActivity(a);
        var lastActB = getLastActivity(b);
        if (lastActA < lastActB) {
            return 1;
        } else if (lastActA > lastActB) {
            return -1;
        }
        return 0;
    });
}
/**
 * Get all topics for the given Sphere chronologically
 * @param {object} group the Sphere i want the topics from
 */ export function getAllTopicsForGroupChronologically(group, topics) {
    return group ? sortChrono(filter(topics, {
        group_id: group.id,
        __hidden: false
    })) : [];
}
